var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMusic = function SvgMusic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.161 2.149a.6.6 0 0 1 .7.592v13.375a3.687 3.687 0 1 1-1.2-2.722V3.449L9.513 5.306v12.867a3.687 3.687 0 1 1-1.2-2.721V4.797a.6.6 0 0 1 .501-.592zM5.828 15.686a2.487 2.487 0 1 0 0 4.972 2.487 2.487 0 0 0 0-4.972m12.346-2.058a2.488 2.488 0 1 0 2.486 2.487 2.49 2.49 0 0 0-2.486-2.487"
  })));
};
export default SvgMusic;